export default "__VITE_ASSET__C8Wr1qTU__"